/* eslint-disable import/order */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IoMdArrowBack } from 'react-icons/io';

import UserName from '../UserName';

import { useEvieAppContext } from 'components/evieApp/EvieAppProvider';

const PersonalData = ({ onGoProfile }) => {
  const { t } = useTranslation();
  const { personalInfo: { name = '', email = '', currentProgram = '' } = {} } = useEvieAppContext();

  return (
    <section className="evie-personal-data">
      <section className="evie-personal-data__topbar">
        <IoMdArrowBack onClick={onGoProfile} />
      </section>
      <header className="evie-profile__header" style={{ padding: '20px' }}>
        <h2 className="evie-profile__header_title">{t('evieApp.profile.title')}</h2>
      </header>
      <UserName displayName={false} />
      <ul className="evie-personal-data__data">
        <li className="evie-personal-data__data_label">
          <h4>{t('evieApp.profile.personalData.name')}</h4>
          <p>{name}</p>
        </li>
        <li className="evie-personal-data__data_label">
          <h4>{t('evieApp.profile.personalData.email')}</h4>
          <p>{email}</p>
        </li>
        <li className="evie-personal-data__data_label">
          <h4>{t('evieApp.profile.personalData.currentProgram')}</h4>
          <p>{currentProgram}</p>
        </li>
      </ul>
    </section>
  );
};

PersonalData.propTypes = {
  onGoProfile: PropTypes.func.isRequired,
};

export default PersonalData;
